export const normalizeFetchAssignmentSharedWithResponse = response =>
    response.map(sharedWith => ({
        id: sharedWith.id,
        level: sharedWith.sharing_level,
        sharedBy: sharedWith.shared_by_user,
        email: sharedWith.email_to,
        isPending: sharedWith.is_pending,
        sharedWithOrganization: sharedWith.share_with_organization,
        user: sharedWith.user && {
            id: sharedWith.user.id,
            name: sharedWith.user.name,
            email: sharedWith.user.email,
            organization: sharedWith.user.organization && {
                id: sharedWith.user.organization.account_id,
                name: sharedWith.user.organization.account_name,
            },
        },
        organization: sharedWith.organization && {
            id: sharedWith.organization.account_id,
            name: sharedWith.organization.account_name,
        },
    }))

export const normalizeFetchSharedAssignmentsResponse = response => ({
    assignments: response.assignments, // adjust it when the assignments page is rebuilt
    totalPages: response.total_pages,
})

export const normalizeFetchPendingShareSuggestionsResponse = response =>
    response.map(request => ({
        id: request.id,
        level: request.sharing_level,
        sharedBy: request.shared_by_user,
        assignment: {
            name: request.assignment.assignment_name,
            token: request.assignment.token,
        },
    }))

export const normalizeFetchSharedAssignmentFiltersResponse = response => ({
    languages: response.languages,
    types: response.assignment_types.map(type => type.id),
    owners: response.owners,
})
